import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckIcon, DefaultText, FlexColumn, FlexRow, PaperBlock, SmallGrayText, SmallText } from '@guryou/html-components';

const SuccessPage = ({ state }) => {
  const { t } = useTranslation();

  return (
    <FlexColumn marginTop={10}>
      <PaperBlock
        marginBottom={2}
        paddingTop={6}
        paddingBottom={6}
        display="flex"
        flexDirection="column"
        alignItems="center"
        borderRadius="12px"
        boxShadow="0 4px 12px rgba(0, 0, 0, 0.05)"
      >
        <FlexRow width="5rem" height="5rem" marginBottom={3} backgroundColor="#4caf50" justifyContent="center" alignItems="center" borderRadius="50%">
          <CheckIcon fontSize="large" htmlColor="white" />
        </FlexRow>

        <DefaultText fontSize="1.6rem" fontWeight={600} marginBottom={2}>
          {t('RIMINI_REGISTER.success')}
        </DefaultText>

        <SmallGrayText textAlign="center" maxWidth="400px">
          {t('RIMINI_REGISTER.checkEmail')}
        </SmallGrayText>
        <SmallText textAlign="center" marginTop={4} maxWidth="400px" wordBreak="break-word" overflowWrap="break-word" whiteSpace="normal">{`${state
          ?.user?.email || 'No email found'}`}</SmallText>
      </PaperBlock>
    </FlexColumn>
  );
};

export default SuccessPage;
